import React, {useContext} from "react";
import fichaPdf from './fichaPdf'
import { BlobProvider } from "@react-pdf/renderer";
import { UserContext } from 'context/userContext'

var isSafari = /constructor/i.test(window.HTMLElement) ||
              (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] ||
              (typeof safari !== 'undefined' && window['safari'].pushNotification));

function FichaLink (props){
    const {userOptions, userProfile} = useContext(UserContext)
    const target = isSafari ? "_self" : "_blank"

    return (
          <BlobProvider key={Math.random()}
                        document={fichaPdf({...userProfile, ...userOptions, ...props.ficha})}
          >
            {({ url }) => ( <a href={url}
                               target={target}
                               rel="noopener noreferrer">
                                  {props.link}
                            </a>
            )}
          </BlobProvider>
    )
  }

export default FichaLink;
